import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { api } from '../../../../../utils'
import { MODALITA_SPEDIZIONE, PROFILOAZIENDA } from '../../../../../utils/endpoint'
import Button from '../../../../atoms/Button/Button'
import FormField from '../../../../atoms/FormField/FormField'
import FormRadio from '../../../../atoms/FormRadio/FormRadio'
import LoadingSvg from '../../../../atoms/Loading/Loading'
import { trackingCheckoutStart } from '../../../../../utils/gtm'
import useTrans from '../../../../../hooks/useTrans'
import { useRouter } from 'next/router'
import * as Sentry from '@sentry/browser'
import { InfoLabel } from '@components/atoms'

const MODES_OPTIONS = {
  SPEDIZIONE: 'Spedizione',
  RITIRO: 'Ritiro',
}

const ModalitaSpedizione = ({ setStep, step, props, isMerceNeutra, carrello_main }) => {
  const [Loading, setLoading] = useState(false)
  const [modalitaSpedizione, setModalitaSpedizione] = useState([])
  const [ritiro, setRitiro] = useState(props.values.tipo_spedizione === MODES_OPTIONS.SPEDIZIONE)

  const [idSpedizione, setIdSpedizione] = useState(
    props.values.tipo_spedizione_id ? props.values.tipo_spedizione_id : null
  )

  const [selectedOption, setSelectedOption] = useState(
    props.values.tipo_spedizione ? props.values.tipo_spedizione : null
  )
  const t = useTrans()
  const router = useRouter()

  const hasPersonalizzazioni = useMemo(() => {
    const personalizzazioniCount = carrello_main?.personalizzazioni_carrello?.length ?? 0
    return personalizzazioniCount > 0
  }, [carrello_main?.personalizzazioni_carrello])

  const removeRitiroOption = useCallback(
    (options) => {
      return options.map((option) =>
        option.modalita === MODES_OPTIONS.RITIRO
          ? {
              ...option,
              disabled: true,
              tooltip: t(
                'Il ritiro in sede non è disponibile per gli ordini che includono articoli personalizzati'
              ),
            }
          : option
      )
    },
    [t]
  )

  useEffect(() => {
    const fetchSpedizioneDati = async () => {
      setLoading(true)
      try {
        // 1. Prima chiamata API: Modalità di spedizione
        const res = await api.get(MODALITA_SPEDIZIONE, {
          params: { lang: router.locale },
        })
        const modalitaData = res.data
        setModalitaSpedizione(
          hasPersonalizzazioni ? removeRitiroOption(modalitaData) : modalitaData
        )

        const haGiaTipoSpedizione = !!props.values.tipo_spedizione_id

        const applicaModalita = (modalitaObj) => {
          if (!modalitaObj) return
          setIdSpedizione(modalitaObj.id)
          setRitiro(modalitaObj.modalita === MODES_OPTIONS.RITIRO)
          setSelectedOption(modalitaObj.modalita)
        }

        // 2. Controllo condizioni per la seconda chiamata
        if (!haGiaTipoSpedizione) {
          const profiloRes = await api.get(PROFILOAZIENDA)
          const profiloData = profiloRes.data
          const profiloModalitaId = profiloData?.indirizzo_sede?.modalita_spedizione_id

          if (profiloData?.indirizzo_sede && profiloModalitaId !== null) {
            const defaultModalita = modalitaData.find((t) => t.id === profiloModalitaId)
            const spedizioneAlternativa = modalitaData.find(
              (t) => t.modalita === MODES_OPTIONS.SPEDIZIONE
            )

            if (defaultModalita) {
              const isRitiro = defaultModalita.modalita === MODES_OPTIONS.RITIRO
              // Se ha personalizzazioni e il default è ritiro, lo forziamo a "Spedizione"
              const usaSpedizioneForzata = hasPersonalizzazioni && isRitiro

              applicaModalita(usaSpedizioneForzata ? spedizioneAlternativa : defaultModalita)
            }
          } else {
            // Fallback se non c'è indirizzo_sede
            const spedizione = modalitaData.find((t) => t.modalita === MODES_OPTIONS.SPEDIZIONE)
            applicaModalita(spedizione)
          }
        }
      } catch (err) {
        console.error(err?.message)
        Sentry.captureException(err)
      } finally {
        setLoading(false)
      }
    }

    fetchSpedizioneDati()
  }, [props.values.tipo_spedizione_id, hasPersonalizzazioni])

  useEffect(() => {
    selectedOption && props.setFieldValue('tipo_spedizione', selectedOption)
    idSpedizione && props.setFieldValue('tipo_spedizione_id', idSpedizione)
  }, [selectedOption, idSpedizione])

  return Loading ? (
    <LoadingSvg />
  ) : (
    <>
      <FormField className="checkout__formfield">
        {modalitaSpedizione &&
          modalitaSpedizione.map((modalita) => (
            <div
              className={
                'checkout__option' +
                (idSpedizione === modalita.id ? ' checkout__option--selected' : '')
              }
              key={modalita.id}
            >
              <FormRadio
                label={
                  modalita.tooltip ? (
                    <InfoLabel
                      label={modalita.descrizione}
                      tooltipLabel={modalita.tooltip}
                      tooltipPos="bottom"
                      className="info-label__icon-wrapper"
                    />
                  ) : (
                    modalita.descrizione
                  )
                }
                key={modalita.id}
                disabled={modalita.disabled}
                checked={idSpedizione === modalita.id ? true : false}
                onClick={() => {
                  setIdSpedizione(modalita.id)
                  setRitiro(modalita.modalita === MODES_OPTIONS.RITIRO ? true : false)
                  setSelectedOption(modalita.modalita)
                }}
              />
            </div>
          ))}
      </FormField>

      <Button
        disabled={selectedOption ? false : true}
        label={t('Conferma Spedizione')}
        variant="primary"
        size="medium"
        onClick={() => {
          setStep(ritiro === false ? step + 1 : isMerceNeutra ? 2 : 2)
          trackingCheckoutStart(carrello_main)
        }}
      />
    </>
  )
}

export default ModalitaSpedizione
